(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vs-video-carousel')) {
    customElements.define(
      'vs-video-carousel',
      class VsVideoCarousel extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('.vs-vc__viewport');
          this.list = this.querySelector('.vs-vc__list');
          if (!this.list) return;

          this.originals = Array.from(this.list.children);
          if (!this.originals.length) return;

          this.perRow = parseInt(this.dataset.perRow, 10) || 5;
          this.scale = (parseInt(this.dataset.scale, 10) || 110) / 100;
          this.autoplay = this.dataset.autoplay === 'true';
          this.single = this.originals.length === 1;
          this.muted = true;
          this.busy = false;
          this.inView = false;
          this.userStarted = false;
          this.userPaused = false;
          this.activeItem = null;

          this.classList.toggle('is-single', this.single);
          if (!this.single) this.fillClones();
          this.items = Array.from(this.list.children);
          this.bindItems();
          this.bindNavigation();
          this.bindTouch();

          this.onResize = this.debounce(() => this.layout(), 120);
          this.resizeObserver = new ResizeObserver(this.onResize);
          this.resizeObserver.observe(this);

          this.intersectionObserver = new IntersectionObserver(
            (entries) => {
              this.inView = entries[0].isIntersecting;
              this.syncVideos();
            },
            { threshold: 0.25 }
          );
          this.intersectionObserver.observe(this);

          this.onBlockSelect = (event) => {
            const item = event.target.closest ? event.target.closest('.vs-vc__item') : null;
            if (item && this.contains(item)) this.goTo(item);
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);

          this.layout();
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.intersectionObserver) this.intersectionObserver.disconnect();
          if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        fillClones() {
          const needed = this.perRow + 2;
          while (this.list.children.length < needed) {
            this.originals.forEach((original) => {
              const clone = original.cloneNode(true);
              clone.setAttribute('aria-hidden', 'true');
              clone.removeAttribute('data-shopify-editor-block');
              clone.querySelectorAll('button').forEach((button) => button.setAttribute('tabindex', '-1'));
              this.list.appendChild(clone);
            });
          }
        }

        bindItems() {
          this.items.forEach((item) => {
            const video = item.querySelector('video');

            if (video) {
              video.muted = true;
              video.addEventListener('play', () => item.classList.add('is-playing'));
              video.addEventListener('pause', () => item.classList.remove('is-playing'));
            }

            item.querySelector('.vs-vc__sound')?.addEventListener('click', (event) => {
              event.stopPropagation();
              this.toggleSound();
            });

            item.addEventListener('click', (event) => {
              if (item !== this.activeItem) {
                if (event.target.closest('.vs-vc__play')) this.userStarted = true;
                this.goTo(item);
                return;
              }

              if (!video) return;

              if (video.paused) {
                this.userStarted = true;
                this.userPaused = false;
              } else {
                this.userPaused = true;
              }
              this.syncVideos();
            });
          });
        }

        bindNavigation() {
          this.querySelector('[data-dir="prev"]')?.addEventListener('click', () => this.go(-1));
          this.querySelector('[data-dir="next"]')?.addEventListener('click', () => this.go(1));
        }

        bindTouch() {
          let startX = null;
          let startY = null;
          let startTime = 0;

          this.list.addEventListener(
            'touchstart',
            (event) => {
              startX = event.touches[0].clientX;
              startY = event.touches[0].clientY;
              startTime = Date.now();
            },
            { passive: true }
          );

          this.list.addEventListener(
            'touchend',
            (event) => {
              if (startX === null) return;
              const diffX = startX - event.changedTouches[0].clientX;
              const diffY = startY - event.changedTouches[0].clientY;
              if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 30 && Date.now() - startTime < 600) {
                this.go(diffX > 0 ? 1 : -1);
              }
              startX = null;
              startY = null;
            },
            { passive: true }
          );
        }

        isDesktop() {
          return window.matchMedia('(min-width: 990px)').matches;
        }

        layout() {
          if (this.busy) {
            this.needsLayout = true;
            return;
          }

          const width = this.viewport.clientWidth;
          if (!width) return;

          this.gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;

          if (this.single) {
            this.center = 0;
            this.base = Math.min(width, this.isDesktop() ? 360 : width * 0.7) / this.scale;
            this.offset = -(width - this.base * this.scale) / 2;
          } else if (this.isDesktop()) {
            const visible = this.perRow;
            this.center = Math.floor(visible / 2);
            this.base = (width - this.gap * (visible - 1)) / (visible - 1 + this.scale);
            this.offset = 0;
          } else {
            const peek = 0.3;
            this.center = 1;
            this.base = (width - this.gap * 2) / (this.scale + peek * 2);
            this.offset = this.base * (1 - peek);
          }

          if (!this.activeItem) {
            const startIndex = this.single ? 0 : Math.min(Math.floor(this.perRow / 2), this.originals.length - 1);
            this.activeItem = this.items[startIndex];
          }

          this.list.classList.add('is-static');
          this.rotateTo(this.activeItem);
          this.markActive(this.activeItem);
          this.setTranslate(-this.offset);
          void this.list.offsetWidth;
          this.list.classList.remove('is-static');
          this.syncVideos();
        }

        rotateTo(item) {
          if (this.single) return;
          let index = Array.from(this.list.children).indexOf(item);
          while (index > this.center) {
            this.list.appendChild(this.list.firstElementChild);
            index -= 1;
          }
          while (index < this.center) {
            this.list.insertBefore(this.list.lastElementChild, this.list.firstElementChild);
            index += 1;
          }
        }

        markActive(item) {
          this.activeItem = item;
          this.items.forEach((entry) => {
            const isActive = entry === item;
            entry.classList.toggle('is-active', isActive);
            entry.style.width = `${isActive ? this.base * this.scale : this.base}px`;
          });
        }

        setTranslate(x) {
          this.list.style.transform = `translate3d(${x}px, 0, 0)`;
        }

        goTo(item) {
          const index = Array.from(this.list.children).indexOf(item);
          if (index === -1) return;
          this.go(index - this.center);
        }

        go(steps) {
          if (this.busy || this.single || !steps) return;

          const children = Array.from(this.list.children);
          const maxRight = children.length - 1 - this.center;
          const count = Math.min(Math.abs(steps), steps > 0 ? maxRight : this.center + 1);
          if (!count) return;

          this.busy = true;
          this.userPaused = false;
          const shift = (this.base + this.gap) * count;

          if (steps > 0) {
            this.markActive(children[this.center + count]);
            this.syncVideos();
            this.animate(-this.offset - shift, () => {
              for (let i = 0; i < count; i += 1) this.list.appendChild(this.list.firstElementChild);
              this.list.classList.add('is-static');
              this.setTranslate(-this.offset);
              void this.list.offsetWidth;
              this.list.classList.remove('is-static');
            });
          } else {
            this.list.classList.add('is-static');
            for (let i = 0; i < count; i += 1) {
              this.list.insertBefore(this.list.lastElementChild, this.list.firstElementChild);
            }
            this.setTranslate(-this.offset - shift);
            void this.list.offsetWidth;
            this.list.classList.remove('is-static');
            this.markActive(this.list.children[this.center]);
            this.syncVideos();
            this.animate(-this.offset, () => {});
          }
        }

        animate(x, done) {
          let finished = false;
          const finish = () => {
            if (finished) return;
            finished = true;
            this.list.removeEventListener('transitionend', onEnd);
            done();
            this.busy = false;
            if (this.needsLayout) {
              this.needsLayout = false;
              this.layout();
            }
          };
          const onEnd = (event) => {
            if (event.target === this.list && event.propertyName === 'transform') finish();
          };
          this.list.addEventListener('transitionend', onEnd);
          setTimeout(finish, 600);
          this.setTranslate(x);
        }

        syncVideos() {
          if (!this.items) return;
          this.items.forEach((item) => {
            const video = item.querySelector('video');
            if (!video) return;
            const shouldPlay =
              item === this.activeItem && this.inView && !this.userPaused && (this.autoplay || this.userStarted);

            video.muted = this.muted;
            if (shouldPlay) {
              const promise = video.play();
              if (promise) promise.catch(() => item.classList.remove('is-playing'));
            } else if (!video.paused) {
              video.pause();
            }
          });
        }

        toggleSound() {
          this.muted = !this.muted;
          this.classList.toggle('is-unmuted', !this.muted);
          this.items.forEach((item) => {
            const video = item.querySelector('video');
            if (video) video.muted = this.muted;
          });
          if (!this.muted) {
            this.userStarted = true;
            this.userPaused = false;
            this.syncVideos();
          }
        }

        debounce(fn, wait) {
          let timer;
          return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn.apply(this, args), wait);
          };
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vs-icons-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vs-icons-bar')) {
    customElements.define(
      'vs-icons-bar',
      class VsIconsBar extends HTMLElement {
        connectedCallback() {
          if (this.dataset.layout !== 'slider') return;

          this.items = Array.from(this.querySelectorAll('.vs-ib__item'));
          if (this.items.length < 2) return;

          this.index = 0;
          this.media = window.matchMedia('(max-width: 989px)');
          this.speed = (parseInt(this.dataset.autoplay, 10) || 0) * 1000;

          this.querySelector('[data-dir="prev"]')?.addEventListener('click', () => this.step(-1, true));
          this.querySelector('[data-dir="next"]')?.addEventListener('click', () => this.step(1, true));

          let startX = null;
          this.addEventListener('touchstart', (event) => (startX = event.touches[0].clientX), { passive: true });
          this.addEventListener(
            'touchend',
            (event) => {
              if (startX === null) return;
              const diff = startX - event.changedTouches[0].clientX;
              if (Math.abs(diff) > 30) this.step(diff > 0 ? 1 : -1, true);
              startX = null;
            },
            { passive: true }
          );

          this.onBlockSelect = (event) => {
            const blockId = event.detail && event.detail.blockId;
            const found = this.items.findIndex((item) => item.dataset.blockId === String(blockId));
            if (found !== -1) {
              this.stop();
              this.show(found);
            }
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);

          this.onMediaChange = () => this.start();
          this.media.addEventListener('change', this.onMediaChange);

          this.show(0);
          this.start();
        }

        disconnectedCallback() {
          this.stop();
          if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
          if (this.media && this.onMediaChange) this.media.removeEventListener('change', this.onMediaChange);
        }

        show(index) {
          this.index = (index + this.items.length) % this.items.length;
          this.items.forEach((item, i) => item.classList.toggle('is-visible', i === this.index));
        }

        step(direction, manual) {
          this.show(this.index + direction);
          if (manual) this.start();
        }

        start() {
          this.stop();
          if (!this.speed || !this.media.matches) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.timer = setInterval(() => this.step(1, false), this.speed);
        }

        stop() {
          if (this.timer) clearInterval(this.timer);
          this.timer = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
